const HeartBorder = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props}>
        <use xlinkHref="#heartBorderSymbol" />
    </svg>
);

export default HeartBorder;
